export const QuickChargerRemainingTimeConstants = {
  Title: "急速充電器 残充電時間",
  OfficeName: "会社／営業所",
  ChargerType: "充電器種別",
  ChargerName: "充電器名",
  ConnectorNo: "コネクタ",
  ChargingStatus: "充電状態",
  ChargingStartDatetime: "充電開始日時",
  ChargingElapsedTime: "経過時間",
  RemainingMinutesToSoc90: "SoC90%まで",
  Soc: "SoC（％）",
  ChargedEnergy: "充電電力量（kWh）",

  IsCharging: "充電中",
  IsNotCharging: "充電なし",

  UnsupportedValue: "-",
  EmptyValue: "",

  RemainingMinutesAttention: "※バッテリー劣化防止推奨である90%までの5分程度の\n誤差を含む目安時間(100%までは追加で90分程度)",
} as const;
